<template lang="html">
  <div>
    <div class="noData">
        <span class="text">
          Click on ‘Add New’ to add new FBP Band in the following list
        </span>
        <button class="addnewbtn" v-if="fbpBandData.length>3" @click="goToAddFbpBandPage()">
          <img src="@/assets/group-5.svg" />
          <b> Add New </b>
        </button>
      </div>
    <div v-if="fbpBandData">
        <data-table
        :columns="fbpBandsColumnNames"
        :tableData="fbpBandData"
        :checkbox="false"
        :withForm="false"
        :showinrow="true"
        :showhistory="false"
        :showedit="true"
        :showdelete="true"
        @editStart="initEditStart"
        @delete="deleteItem">
        <template v-slot:rowcontent="slotprops">
           <p v-if="slotprops.value.column.key =='fromCtc'">{{slotprops.value.record.fromCtc}} - {{slotprops.value.record.toCtc}}</p>
           <p v-if="slotprops.value.column.key !='fromCtc'">{{slotprops.value.record[slotprops.value.column.key]}}</p>
        </template>
      </data-table>
    </div>
    <form-add-button
        v-show="showBtn && fbpBandData.length<=3"
        main_text="+ Add New"
        sub_text="FBP Band"
        @click="goToAddFbpBandPage()"
        >
    </form-add-button>

    <pop-up-message
      v-if="showConfirmDeletePopup"
      :message="'Are you sure you wish to delete ?'"
      :popupType="popupType"
      :popupHeaderMessage="'Confirm Delete'">
      <template v-slot:bottomContent>
        <btn-grp>
          <popup-btn text="Cancel" type="secondary" @click="cancelEvent" />
          <popup-btn text="Delete" type="primary" @click="deleteEvent" />
        </btn-grp>
      </template>
    </pop-up-message>

    <bottom-action-container class="placeAtEnd">
      <btn-skip @navClicked="$emit('skip')"/>
        <template slot="end">
          <btn-grp>
            <btn text="Previous" type="secondary" @click="$emit('previous')"/>
            <btn text="Next" type="primary" @click="$emit('next')" />
          </btn-grp>
        </template>
    </bottom-action-container>
  </div>
</template>

<script>
import {
  mapState,
  mapActions,
  mapGetters
} from 'vuex';

export default {
  mounted() {
    this.fetchAll();
  },
  activated() {
    this.fetchAll();
  },
  computed: {
    ...mapState('onboard/fbpBands', {
      fbpBandData: state => state.data,
      isFetching: state => state.isFetching,
      isSaving: state => state.isSaving,
      isDeleting: state => state.isDeleting
    }),
    ...mapGetters({
       getleid:'onboard/legal_entities/legal_entity_ID',
    }),
    le_id(){
      if(this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index)
      else{
          return this.getleid(0)
      }
    },
    isLoading() {
      return this.isFetching;
    }
  },
  data() {
    return {
      mode: 'add',
      showBtn: true,
      record: {},
      currentObj: {},
      popupType: "ConfirmDelete",
      showConfirmDeletePopup: false,
      fbpBandsColumnNames: [{
          label: 'Name',
          key: 'name'
        },
        {
          label: 'CTC',
          key: 'fromCtc'
        },
        {
          label: 'Description',
          key: 'description'
        }
      ],
    }
  },
  methods: {
    ...mapActions('onboard/fbpBands/', {
      act_fetchAll: 'fetchAll',
      act_update: 'update',
      act_delete: 'delete',
      act_changeEditMode: 'changeEditMode'
    }),
    

    /* server call to delete a FBP band */
    async deleteEvent() {
      try {
        let res = await this.act_delete(this.currentObj);
        if (res.data.status) {
          this.fetchAll();
          this.showConfirmDeletePopup = false;
        }
      }
      catch(err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to open delete confirmation pop-up */
    deleteItem(item) {
      this.currentObj = item;
      this.showConfirmDeletePopup = true;
    },

    /* function to hide delete confirmation pop-up */
    cancelEvent() {
      this.showConfirmDeletePopup = false;
    },

    /* function to edit the FBP band */
    async initEditStart(record){
      try {
        await this.act_changeEditMode({editMode: true, record: record})
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/${this.$route.params.step_name}/modifyFbpBand`
        })
        this.$emit('gobackToFbp')
      }
      catch(err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to create the FBP band */
    async goToAddFbpBandPage() {

      try {
        await this.act_changeEditMode({editMode: false, record: {}})
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/${this.$route.params.step_name}/addFbpBand`
        })
      }
      catch(err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* server call to get all FBP bands */
    async fetchAll() {
      try {
        let res = await this.act_fetchAll({
          'le_id': this.le_id
        });
      }
      catch(err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.noData{
  height: 55px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .text {
    color: #858585;
    font-size: 14px;
  }
}

.addnewbtn {
  float: right;
  b{
    margin-left: 8px;
    color: #34c0be;
  }
}
</style>
